import React, { useState, useEffect } from "react";
import { useToast } from "../../Utils/toastContext";

const Alerts = () => {
  const { showToast } = useToast();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handle alert clicks
  const handleAlertClick = (alert) => {
    // Navigate to the investment menu page
    window.location.href = `${alert.alert_URL}${alert.inv_id}`;
  };

  const processAlertsData = (alertsData) => {
    return alertsData.map(alert => {
      let updatedAlert = { ...alert };

      if (updatedAlert.inv_investment_type_tag === 1) {
        updatedAlert.alert_URL = '/investment-advisor-menu/';
        if (updatedAlert.inv_type !== 'Private Label') {
          updatedAlert.inv_type = updatedAlert.inv_type + ' (MIS)';
        }
        updatedAlert.inv_type = 'MIS';
      } else if (updatedAlert.inv_investment_type_tag === 2) {
        updatedAlert.alert_URL = '/investment-multi-asset/';
        updatedAlert.inv_amount = updatedAlert.ms_min_investment;
        updatedAlert.inv_type = 'Model Portfolio';
      } else {
        updatedAlert.alert_URL = '/investment-multi-asset/';
      }

      return updatedAlert;
    });
  };

 

  // Enhanced dashboard API function with full chart processing (for future use)
  const getDashboard = async () => {
    try {
      const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
      
      const formData = new FormData(); 
      const systemToken = localStorage.getItem('systemToken') || "";
 
      formData.append('user_token', systemToken); 
      const response = await fetch(`${Base_url}/dashboard`, {
        method: 'POST',
        body: formData
      }); 
      
      if (response.ok) {
        const data = await response.json();
      
        if (data.success === 200) {
          // Process alerts data
          console.log("Dashboard data", data);
          const alertsData = data.dashboard.alerts || [];
          
          const processedAlerts = processAlertsData(alertsData);
          
          setAlerts(processedAlerts);
          
          // Set dashboard data
          // setDashboard(data.dashboard);
          // setYearChartValues(data.dashboard.year_chart);
          
          // Process chart data
          const chartInfo = data.dashboard;
          if (data.dashboard.year_chart && data.dashboard.year_chart.length > 0) {
            // setChart1(data.dashboard.last_month_chart || []);
            // setChart2(data.dashboard.three_month_chart || []);
            // setChart3(data.dashboard.six_month_chart || []);
            // setChart4(data.dashboard.year_chart.reverse() || []);
          }
          
          // Process all time chart
          const allChart = chartInfo.all_chart || [];
          const newChart5 = [];
          const labels = [];
          
          if (allChart.length === 1) {
            newChart5.push(0);
            labels.push((allChart[0].year - 1));
          }
          
          for (let i = 0; i < allChart.length; i++) {
            newChart5.push(allChart[i].balance);
            labels.push(allChart[i].year);
          }
          
          // setChart5(newChart5);
          // setOnChart(1);
        }
      }
    } catch(error){
      console.error('Error fetching dashboard:', error);
      showToast('Failed to fetch dashboard data', 'error');
    }
  };

  useEffect(() => {
    // const localStorageData = {
    //   'access-token': localStorage.getItem('access-token')
    // };
    
    // if (localStorageData['access-token']) {
        getDashboard();
    // }
  }, []);

  return (
    <div className="pt-4 lg:min-w-[79vw] lg:max-w-[80vw]">
      <div className="p-4 bg-white border-radius-10 text-left">
        

        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : alerts && alerts.length > 0 ? (
          <div>
          
            <table className="min-w-full divide-y divide-gray-200">
  <thead className="bg-gray-50">
    <tr>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Investment Name</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Interest Rate</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Min Investment</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Reference Code</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
            {alerts.map((alert, index) => (
      <tr key={alert.alert_id || index} onClick={() => handleAlertClick(alert)} className="hover:bg-gray-100 cursor-pointer">
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{alert.inv_name} - {alert.ms_type}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{alert.inv_interest_rate ? `${alert.inv_interest_rate} %` : 'N/A'}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Min Investment</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{alert.inv_ref_code}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{alert.inv_type}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{alert.location || 'N/A'}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{alert.inv_amount} {alert.currency}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
          <span className={alert.inv_status === 'Active' ? 'active_s' : 'pending_s'}>
                    {alert.inv_status}
                  </span>  
        </td>
      </tr>
            ))}   
  </tbody>
</table>
            {alerts.length === 0 && (
              <div id="alert_list" style={{width: "auto", height: "320px"}}>
                <p className="font-grey text-center">No records found !!</p>
              </div>
            )} 
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="text-gray-400 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15 17h5l-5 5v-5zM9 6l-5 5h5V6zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
            </div>
            <p className="text-gray-500 text-lg">No investment alerts found</p>
            <p className="text-gray-400 text-sm mt-2">Check back later for new investment opportunities</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alerts;
